export default class DatePicker {
	constructor(calendar) {
		this.handleDatePicker(calendar);
		this.handleDateElementUpdate(calendar);
		this.updateDateElement(calendar);
	}

	handleDatePicker(calendar) {
		const input = calendar.querySelector('.espiritualidade-date-picker');

		document.addEventListener('click', (e) => {
			if (calendar.contains(e.target) && e.target !== input) {
				if (input.classList.contains('closed')) {
					input.classList.remove('closed');
					input.showPicker();
				} else {
					input.classList.add('closed');
				}

			} else {
				input.classList.add('closed');
			}
		});
	}

	handleDateElementUpdate(calendar) {
		const input = calendar.querySelector('.espiritualidade-date-picker');

		input.addEventListener('change', () => {
			input.classList.add('closed');
			this.updateDateElement(calendar);
		});
	}

	updateDateElement(calendar) {
		const input = calendar.querySelector('.espiritualidade-date-picker');
		const dayElement = calendar.querySelector('span.espiritualidade-date-day');

		let date;

		if (input.value) {
			const [year, month, day] = input.value.split('-').map(Number);
			date = new Date(year, month - 1, day, 12, 0, 0);

		} else {
			date = new Date();
		}

		if (date && dayElement) {
			const day = date.getDate().toString().padStart(2, '0');
			const weekday = this.getWeekDay(date);

			dayElement.innerText = `${day}, ${weekday}`;
		}
	}

	getWeekDay(date) {
		const weekDays = [
			"Domingo",
			"Segunda-feira",
			"Terça-feira",
			"Quarta-feira",
			"Quinta-feira",
			"Sexta-feira",
			"Sábado"
		];

		return weekDays[date.getDay()];
	}
}
